import TextField from "@material-ui/core/TextField";
import * as React from "react";
import "./TextInput.scss";

interface TextInputProps {
  id?: string;
  label?: string;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value: string | any;
  required?: boolean;
  className?: string;
  maxLength?: number | string;
  disabled?: boolean;
  isNumeric?: boolean;
  isDate?: boolean;
}

const TextInput = (props: TextInputProps) => (
  <TextField
    required={props.required}
    type={props.isNumeric ? "number" : props.isDate ? "date" : "text"}
    className={props.className ? `TextInput ${props.className}` : "TextInput"}
    InputProps={{
      classes: {
        focused: "TextInput__container--focused",
        notchedOutline: "TextInput__outline"
      } as any
      // noticedOutline is not included in the InputProps type definition
      // but is still used as a prop in OutlinedInput
    }}
    InputLabelProps={{
      classes: {
        root: "TextInput__label",
        shrink: "TextInput__label--shrink"
      }
    }}
    inputProps={{
      maxLength: props.maxLength ? props.maxLength : 250,
      max: "9999-12-31"
    }}
    value={props.value}
    onChange={props.onChange}
    name={props.name}
    id={props.id}
    variant="outlined"
    label={props.label}
    error={false}
    placeholder={props.placeholder}
    disabled={props.disabled}
  />
);

export default TextInput;



// WEBPACK FOOTER //
// ./src/shared/TextInput.tsx